import React, { useState } from 'react'
import Header from '../../../Components/Header'
import Footer from '../../../Components/Footer'
import '../../../Components/Css/login.css'
import { showToast } from '../../../Components/Utlis/toastUtlis'
import { ApiService } from '../../../Components/Services/apiServices'
import { useNavigate } from 'react-router-dom'

const Login = () => {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!email) {
      showToast("error", "Please Enter Email");
      setLoading(false);
      return false;
    }

    if (!password) {
      showToast("error", "Please Enter Password");
      setLoading(false);
      return false;
    }

    try {
      const loginData = await ApiService.Commanpostrequest("login", { email, password });

     
      if (loginData.success) {
        showToast("success", "Login Successfully!");
        
        navigate('/');
      } else {
        showToast("success", loginData.message);
        setPassword("");
        window.location.href = "https://sigohrmlpadmin.loopring.in/organisation/dashboard";
      }
    } catch (error) {
      console.error("Login error: ", error);
      if (error.response && error.response.status === 401) {

        showToast("error", "Invalid credentials. Please try again.");
        setEmail("");
        setPassword("");
      } else {
        showToast("error", "An error occurred. Please try again later.");
      }
    } finally {
      setLoading(false);
    }
  }



  return (
    <>

      <div className="hold-transition login-page">
        <div className="login-box">
          <div className="card card-outline card-primary">
            <div className="card-header text-center">
              <a href="#" className="h1">
                <b>Sigo<span style={{ color: 'green', fontSize: "32px" }}>Hrm</span></b>
              </a><br />
              <span style={{ color: 'blue', marginTop: "20px", fontSize: "16px" }}>Organisation Login</span>
            </div>
            <div className="card-body">
              <p className="login-box-msg text-center">Welcome Back !</p>
              <p className="login-box-msg text-center">Sign in to start your session</p>

              <form onSubmit={handleLogin}>
                <div className="input-group mb-3">
                  <input name="email" type="email" className="form-control"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <div className="input-group-append">
                    <div className="input-group-text">
                      <span className="fas fa-envelope" />
                    </div>
                  </div>
                </div>
                <div className="input-group mb-3">
                  <input name="password" type="password" className="form-control"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <div className="input-group-append">
                    <div className="input-group-text">
                      <span className="fas fa-lock" />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-8">
                    <div className="icheck-primary">
                      <input type="checkbox"
                        id="remember"
                        name="remember"

                      />
                      <label htmlFor="remember">
                        Remember Me
                      </label>
                    </div>
                  </div>
                </div>
                <div className="social-auth-links text-center mt-4 mb-3">
                  <button type="submit" className="btn btn-primary w-100 btn-block" disabled={loading}>
                    {loading ? "Signing in..." : "Sign In"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}

export default Login
